import React from 'react'
import { Table, Space, Tag, Button, Skeleton, Popover } from 'antd'
import Title from '../../system/title/Title'
import useSWR from 'swr'
import ApiManager from '../../../business/services/ApiManager'
import { toDate } from '../../../helpers/dateFormatHelper'
import Section from '../section/Section'
import CreditCardPreview from '../creditCardPreview/CreditCardPreview'
import { InjectedCheckoutForm } from '../CardForm'
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import { createLoadingSelector } from '../../../business/selectors/loadingSelectors';
import { useSelector } from 'react-redux';
import { RootState } from '../../../model/rootReducer';

// Make sure to call `loadStripe` outside of a component’s render to avoid
// recreating the `Stripe` object on every render.
const stripePromise = loadStripe('pk_test_51Ho9GKCGGLvERc3NFmvZYLtqWKIrInb7PvkHlWQDkAXzrhpHcmKsucR8kuBn71UOWuINGYXHbVe9CQfEALu20ieh00JvE8Wmgk')

const PaymentMethodList = () => {
    const { data, error } = useSWR(
        'PaymentMethods', (_key) => ApiManager.customers.getPaymentMethods()
    )
    const loadingSelector = createLoadingSelector(['ATTACH_PAYMENT_METHOD']);
    const isFetching = useSelector((state: RootState) => loadingSelector(state));

    if (error) return <div>failed to load</div>
    if (!data || isFetching) return <Skeleton active />

    return (
        <Section title="Moyen de paiements">
            {data.data.map((paymentMethod: any) => {
                return (
                    <CreditCardPreview
                        brand={paymentMethod.brand}
                        expirationDate={paymentMethod.expirationDate}
                        last4={paymentMethod.last4Digit}
                    />
                )
            })}
            <Popover
                content={
                    <Elements stripe={stripePromise}>
                        <InjectedCheckoutForm />
                    </Elements>
                }
                placement="right"
                trigger="click"
            >
                <Button>+</Button>
            </Popover>
        </Section>
    )
}

export default PaymentMethodList
